const rgbaToHex = rgba => {
  const match = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) return 0xffffff;

  const [_, r, g, b] = match.map(Number);
  return (r << 16) | (g << 8) | b;
};

const getScale = () => {
  if (typeof window === "undefined") return 1;
  const width = window.innerWidth;
  if (width < 768) return 0.6;
  if (width < 1024) return 0.8;
  return 1;
};

export { rgbaToHex, getScale };
